module.exports = __webpack_public_path__ + "img/18_57.513fc30c.png";